import { MobileCointainer, MobileWrapper, RowWrapper, ColumnWrapper } from "./ManageInvoiceMobileView.styles";
import { CustomTooltip } from "./ManagePrimaryContactInvoice.styles";
import * as StyledGlobalCSS from "../constants/common/StyledGlobalConstants";
import { firstNameLastName } from "../util/util";
import "./manageInvoice.css";
import { useTranslation } from "react-i18next";
import DeleteIcon from "../assets/icons/delete-icon-mip.png";
import DeleteIconDisabled from "../assets/icons/delete-icon-disabled-mip.png";
import PropTypes from "prop-types";

const ManageInvoiceMobileView = ({ invoice, toogleSwitch, isToggleDisabled, removeContactHandler, isAnyContactPending, showDeleteIcon }) => {
  const [t] = useTranslation("manageInvoiceTranslation");
  return (
    <MobileCointainer>
      {invoice.length > 0 ? (
        invoice.map((data, index) => (
          <MobileWrapper 
          key={`invoice-${index}-${data.emailId}`}>
            <RowWrapper>
              <ColumnWrapper fontWeight="Bold">{t("Full Name")}</ColumnWrapper>
              <ColumnWrapper fontWeight="400" className="Invoice_Ellipsis">
                {firstNameLastName(data)}
              </ColumnWrapper>
            </RowWrapper>
            <RowWrapper>
              <ColumnWrapper fontWeight="Bold">{t("Email Address")}</ColumnWrapper>
              <ColumnWrapper fontWeight="400" className="Invoice_Ellipsis">
                {data.emailId}
              </ColumnWrapper>
            </RowWrapper>
            <RowWrapper>
              <ColumnWrapper fontWeight="Bold">{t("Receive Invoices")}</ColumnWrapper>
              <ColumnWrapper fontWeight="400">
                {data.receiveInvoices === true && isToggleDisabled === true ? (
                  <CustomTooltip
                    renderAnchorElement={() => (
                      <StyledGlobalCSS.MediumText>
                        <div>{toogleSwitch(data)}</div>
                      </StyledGlobalCSS.MediumText>
                    )}
                  >
                    {t(
                      "To set this to No, you must first set another email address to Yes. There must always be at least one email address set to receive invoices."
                    )}
                  </CustomTooltip>
                ) : (
                  <>{toogleSwitch(data)}</>
                )}
              </ColumnWrapper>
            </RowWrapper>
            <RowWrapper>
              <ColumnWrapper fontWeight="Bold">{t("Status")}</ColumnWrapper>
              <ColumnWrapper fontWeight="400">{t(data.status)}</ColumnWrapper>
            </RowWrapper>
            <RowWrapper>
              <ColumnWrapper fontWeight="Bold">{t("Action")}</ColumnWrapper>
              <ColumnWrapper fontWeight="400">
                {showDeleteIcon && (
                  <button
                    style={{
                      padding: "0px",
                      margin: "0px",
                      background: "transparent",
                      border: "none",
                    }}
                    aria-label="Delete button"
                    tabIndex="0"
                    onClick={() => removeContactHandler(data)}
                    disabled={(data.receiveInvoices === true && isToggleDisabled === true) || isAnyContactPending}
                    id="invoice-preference-delete"
                  >
                    <img
                      style={{ width: "1rem", height: "1rem", marginTop: "5px", cursor: "pointer" }}
                      alt="delete_button"
                      src={(data.receiveInvoices === true && isToggleDisabled === true) || isAnyContactPending ? DeleteIconDisabled : DeleteIcon}
                    />
                  </button>
                )}
              </ColumnWrapper>
            </RowWrapper>
          </MobileWrapper>
        ))
      ) : (
        <h4 style={{ textAlign: "left" }}>{t("No Records to display")}</h4>
      )}
    </MobileCointainer>
  );
};

ManageInvoiceMobileView.propTypes = {
  invoice: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      emailId: PropTypes.string.isRequired,
      receiveInvoices: PropTypes.bool,
      status: PropTypes.string
    })
  ).isRequired,
  toogleSwitch: PropTypes.func.isRequired,
  isToggleDisabled: PropTypes.bool,
  removeContactHandler: PropTypes.func.isRequired,
  isAnyContactPending: PropTypes.bool,
  showDeleteIcon: PropTypes.bool
};

export default ManageInvoiceMobileView;
